import { Select } from 'antd';
import { SelectProps } from 'antd/lib/select';
import { noop } from 'lodash';
import React from 'react';
import { useQuery } from 'react-query';
import {
  getUserListByMgidAndJob,
  MgUserResponse,
} from 'services/parametersService';

export type MgUserListByJobSelectProps = {
  mgid?: number;
  jobcode?: string;
  value?: MgUserResponse;
  onChange?: (userListByMgidAndJob?: MgUserResponse) => void;
  onSelected?: (userListByMgidAndJob: MgUserResponse) => void;
  disabled?: boolean;
  allowClear?: boolean;
  style?: any;
};

const MgUserListByJobSelect = ({
  mgid,
  jobcode,
  value,
  onChange = noop,
  onSelected,
  ...otherProps
}: MgUserListByJobSelectProps) => {
  const { data: userListByMgidAndJob, isLoading } = useQuery<MgUserResponse[]>(
    [
      'getUserListByMgidAndJob',
      {
        mgid: mgid ? mgid : Number(localStorage.getItem('mgid')) ?? 0,
        jobcode: jobcode,
      },
    ],
    () => {
      return getUserListByMgidAndJob({
        mgid: mgid ? mgid : Number(localStorage.getItem('mgid')) ?? 0,
        jobcode: jobcode ?? '',
      }).then((res) => res.list || []);
    },
    {
      enabled:
        !!localStorage.getItem('mgid') &&
        jobcode !== '' &&
        jobcode != null &&
        jobcode !== undefined,
    }
  );

  const handleChange: SelectProps<any>['onChange'] = (value, option) => {
    onChange(value);
    if (onSelected) {
      onSelected(
        userListByMgidAndJob?.find((item) => item.mguserid === value)!
      );
    }
  };
  return (
    <Select
      value={value?.userid}
      onChange={handleChange}
      {...otherProps}
      loading={isLoading}
    >
      {userListByMgidAndJob?.map((e) => (
        <Select.Option value={e.userid} key={e.mguserid}>
          {e.name + ' ' + e.surname}
        </Select.Option>
      ))}
    </Select>
  );
};

export default MgUserListByJobSelect;
